import React from 'react'
import Ink from 'react-ink'

import { IButtonProps } from './interfaces'

import { Container, Icon, Loader } from './styles'

const Button: React.FC<IButtonProps> = (props) => (
  <Container disabled={props.isLoading || props.isDisabled} {...props}>
    <Ink />

    {props.isLoading ? <Loader /> : props.icon && <Icon name={props.icon} />}

    {props.children}
  </Container>
)

Button.defaultProps = {
  forwardedAs: 'button',
  variant: 'primary',
}

export default Button
